<template>
	<div class="mainBox" @click.capture="handleGxzzProductNavigationClick">
		<div class="bg">
			<!-- 顶部导航 -->
			<SubHeader
				ref="subTops"
				isShare
				:companyId="companyInfo?.companyId || companyId"
				:searchProps="{
					showBorder: true,
					companyId: companyInfo?.companyId || companyId,
				}"
			/>

			<!-- 站点信息 -->
			<SiteInfo
				:companyInfo="companyInfo"
				:initialProductCount="ssrProductCount ?? 0"
				@certification-click="trackGxzzSubsiteHomeClick('资质证照')"
			/>

			<!-- 轮播图 -->
			<van-swipe class="swiper" circular :autoplay="3000" :duration="500" :indicator-color="'#FFFFFF'" :indicator-active-color="'#46539D'">
				<van-swipe-item v-for="(item, i) in banner" :key="i">
					<div class="swiper-item">
						<a v-if="getBannerHref(item)" :href="getBannerHref(item)" class="banner-link" @click.prevent="bannerjumpTo(item)">
							<NuxtImg
								:src="compPic(item.mapUrl)"
								:alt="item.title || `${companyInfo?.companyName || '子站'}轮播图`"
								style="width: 100%; height: 15.2rem"
								format="webp"
							/>
						</a>
						<NuxtImg
							v-else
							:src="compPic(item.mapUrl)"
							:alt="item.title || `${companyInfo?.companyName || '子站'}轮播图`"
							style="width: 100%; height: 15.2rem"
							format="webp"
						/>
					</div>
				</van-swipe-item>
			</van-swipe>

			<!-- 四个标题 -->
			<div class="title-box">
				<span>央企平台</span>
				<span>海量品种</span>
				<span>放心服务</span>
				<span>便捷采购</span>
			</div>

			<!-- 四个卡片 -->
			<div class="specialListBox">
				<template v-for="(item, i) in mergePreviewImgConfig(cardList)" :key="i">
					<a v-if="getCardHref(item)" :href="getCardHref(item)" class="specialList" @click.prevent="toMoreURL(item)">
						<NuxtImg :src="item.mapUrl" :alt="item.title || '子站专区卡片'" format="webp" />
					</a>
					<div v-else class="specialList">
						<NuxtImg :src="item.mapUrl" :alt="item.title || '子站专区卡片'" format="webp" />
					</div>
				</template>
			</div>

			<!-- 店铺资讯 -->
			<a :href="getInfoHref()" class="gykx-box" @click.prevent="toInfo">
				<div class="gykx-content">
					<img src="/staticSeo/images/childSite/dianpuzixun.png" alt="店铺资讯" />
					<van-swipe class="lunbo" circular :autoplay="3000" :duration="500" vertical :show-indicators="false">
						<van-swipe-item v-for="(item, i) in newsList" :key="i">
							<div class="text">{{ item.title }}</div>
						</van-swipe-item>
					</van-swipe>
				</div>
				<i class="iconfont icon-gongneng_xiangyou-37"></i>
			</a>
		</div>

		<!-- 热门分类 -->
		<div class="ClassifyBox">
			<a :href="getMoreClassifyHref()" class="topTitle" @click.prevent="toMoreClassify">
				<div class="HotTitle">热门分类</div>
				<i class="iconfont icon-gongneng_sandiangengduo"></i>
			</a>
			<div class="hotList">
				<a
					v-for="(item, j) in productCategoryList.slice(0, 6)"
					:key="j"
					:href="getClassifyHref(item)"
					class="hotClassifyBox"
					@click.prevent="toClassify(item)"
				>
					<NuxtImg
						style="margin: 0 auto"
						:src="item.mobileImageUrl || '/staticSeo/images/placeholder.png'"
						:alt="(item.categoryName || '').trim()"
						width="5.75rem"
						height="5.75rem"
						format="webp"
					/>
					<div class="titles">
						{{ item.categoryName }}
					</div>
				</a>
				<!-- 补齐空位 -->
				<template v-if="productCategoryList.length % 3 !== 0">
					<div v-for="o in 3 - (productCategoryList.length % 3)" :key="'empty' + o" class="hotClassifyBox"></div>
				</template>
			</div>
		</div>

		<!-- 热门厂家 -->
		<div>
			<div v-for="(item, ns) in factoryDataList" :key="ns" class="speciaBox">
				<div class="topTitle">
					<div class="TopBoxTitle bg1">
						{{ item.title }}
					</div>
				</div>
				<div class="productList1">
					<a
						v-for="(items, j) in item.columnProductList"
						:key="j"
						:href="getFactoryProductHref(items)"
						class="productBox"
						@click.prevent="toProductDitall1(items)"
					>
						<NuxtImg
							style="margin: 0 auto"
							:src="items.linkUrl || items.imageUrl || '/staticSeo/images/placeholder.png'"
							:alt="`${item.title || '厂家'} 展示图`"
							width="100%"
							height="7.55rem"
							format="webp"
						/>
					</a>
				</div>
			</div>
		</div>

		<!-- 栏目 -->
		<div v-for="(item, i) in hotProductData" :key="i" class="speciaBox" :class="'speciaBox_' + item.viewType">
			<div v-if="item.viewType === '1p2'" class="layout-1-2">
				<a v-if="getMoreHref(item)" :href="getMoreHref(item)" class="left-banner" @click.prevent="toMore(item)">
					<NuxtImg
						:src="(item.list && item.list[0] && (item.list[0].linkUrl || item.list[0].imageUrl)) || '/staticSeo/images/placeholder.png'"
						:alt="item.title || '栏目主图'"
						width="100%"
						height="100%"
						format="webp"
					/>
				</a>
				<div v-else class="left-banner">
					<NuxtImg
						:src="(item.list && item.list[0] && (item.list[0].linkUrl || item.list[0].imageUrl)) || '/staticSeo/images/placeholder.png'"
						:alt="item.title || '栏目主图'"
						width="100%"
						height="100%"
						format="webp"
					/>
				</div>
				<div class="right-products">
					<div class="product-card">
						<BigImg :dataList="item.list.slice(1, 3)" :showSite="false" fromPage="子站首页" />
					</div>
				</div>
			</div>
			<div v-else>
				<div class="topTitle">
					<div class="TopBoxTitle" :class="item.bg">
						{{ item.title }}
					</div>
					<a v-if="item.moreInfoUrl" :href="getMoreHref(item)" class="more-link" @click.prevent="toMore(item)">
						<i class="iconfont icon-gongneng_sandiangengduo"></i>
					</a>
				</div>
				<div class="productList">
					<ProductCard
						v-for="(items, j) in item.list"
						:key="j"
						:imageUrl="items.linkUrl || items.imageUrl || '/staticSeo/images/placeholder.png'"
						:productName="items.productName"
						:coupon="items.coupon"
						:zero="items.zero"
						:activityType="items.activityType"
						:productData="items"
						:href="getProductDetailHref(items)"
						@click="toProductDitall"
					/>
					<!-- 补齐空位 -->
					<template v-if="item.list.length % 3 !== 0">
						<div v-for="o in 3 - (item.list.length % 3)" :key="'empty' + o" class="productBox"></div>
					</template>
				</div>
			</div>
		</div>

		<!-- 国械智造：留言咨询楼层（columnType 9/12，对齐 PC Type9_fl_msg） -->
		<div v-if="isGxzzSite && gxzzConsultFloors.length">
			<div v-for="(floor, floorIndex) in gxzzConsultFloors" :key="floor.layoutPlateId || `gxzz-consult-${floorIndex}`">
				<GxzzSiteHeadlines
					v-if="showGxzzHeadlineBeforeConsult && floorIndex === gxzzHeadlineInsertIndex && gxzzNewsList.length"
					:company-id="companyId"
					:news-list="gxzzNewsList"
				/>
				<FloorColumn class="gxzz-consult-floor" :item="floor" :option="columnOption" />
			</div>
			<GxzzSiteHeadlines v-if="showGxzzHeadlineAfterConsult && gxzzNewsList.length" :company-id="companyId" :news-list="gxzzNewsList" />
		</div>
		<GxzzSiteHeadlines v-else-if="isGxzzSite && gxzzNewsList.length" :company-id="companyId" :news-list="gxzzNewsList" />

		<!-- 底部导航 -->
		<SubFoot />

		<!-- 回到顶部 -->
		<GoTop :scrollTop="scrollTop" />
	</div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useRoute, navigateTo } from '#app';
import { getBannerList, getBannerListNoLogin, getNewsList, getNewsListNoLogin, queryByCompanyIdAndPublishTypeAll } from '@/api/childSite.js';
import { getUserSite, getMobileCategory, queryWebsiteByCompanyId, getGoodsPricePre, getHotNews } from '@/api/index';
import { getActiveProduct } from '@/api/order.js';
import { getDiscountList } from '@/api/goods.js';
import { compressPic } from '@/utils/utils';
import { mobileProductDetailPath } from '@/utils/link/mobileProductDetail';
import { mobileSpecialDetailPath } from '@/utils/link/mobileSpecialDetail';
import { mateUrl } from '@/utils/mateUrl.js';
import { mergeProductPriceFields } from '@/utils/productPrice';
import * as _ from 'lodash-es';
import dayjs from 'dayjs';
import SiteInfo from './SiteInfo.vue';
import ProductCard from './ProductCard.vue';
import GxzzSiteHeadlines from './GxzzSiteHeadlines.vue';
import FloorColumn from '@/components/column/index.vue';
import BigImg from '@/components/BigImg.vue';
import { isGxzzFromWebsiteData } from '@/utils/business/siteGxzz.js';
import { setIsGxzzSession } from '@/utils/gxzz';
import { getStorageSync, setStorageSync } from '@/utils/storage.js';
import { buildCategoryDetailPath } from '#shared/categoryRoutes';
import { useAnalytics } from '@/composables/useAnalytics';
import { consumeGxzzTrackingContext, GXZZ_TRACKING_CHANNEL, GXZZ_TRACKING_TARGET, setGxzzProductTrackingContextByHref } from '@/utils/gxzzTracking';

const route = useRoute();
const config = useRuntimeConfig();
const { trackEvent } = useAnalytics();

/** 子站路由上的 companyId（与 query 兜底），供 SSR 与 useAsyncData 使用 */
const effectiveCompanyId = computed(() => route.params.companyId ?? route.query.companyId ?? null);

// 响应式数据
const scrollTop = ref(0);
const placeholders = ref('搜本店');
const companyId = ref(null);
const isLogin = ref(false);
const factoryDataList = ref([]);
const hotProductData = ref([]);
const productData = ref([]); // 收集所有产品数据，参考 DC 项目
const cardList = ref([]);
const banner = ref([]);
const newsList = ref([]);
const gxzzHeadlineList = ref([]);
const productCategoryList = ref([]);
const companyInfo = ref({});
const publishTypeMap = ref({});
const floorListData = ref([]);

const GXZZ_CONSULT_COLUMN_TYPES = new Set([9, 12]);

/** 从楼层行解析 CMS 栏目数据（与 PC allListDate 取 contentList[0] 一致） */
const toColumnFloorItem = row => {
	const content = row?.contentList?.[0];
	if (!content?.columnType) return null;
	return { ...content, publishType: row.publishType, sort: row.sort };
};

const gxzzConsultFloors = computed(() => {
	if (!isGxzzSite.value) return [];
	return floorListData.value
		.map(toColumnFloorItem)
		.filter(item => item && GXZZ_CONSULT_COLUMN_TYPES.has(Number(item.columnType)))
		.sort((a, b) => Number(b.sort) - Number(a.sort));
});

const gxzzHeadlineInsertIndex = computed(() => gxzzConsultFloors.value.findIndex(item => GXZZ_CONSULT_COLUMN_TYPES.has(Number(item.columnType))));

const showGxzzHeadlineBeforeConsult = computed(() => gxzzHeadlineInsertIndex.value < gxzzConsultFloors.value.length);
const showGxzzHeadlineAfterConsult = computed(
	() => isGxzzSite.value && gxzzNewsList.value.length > 0 && gxzzHeadlineInsertIndex.value >= gxzzConsultFloors.value.length
);

const columnOption = computed(() => ({
	backgroundColor: '#455bd9',
	isGxzz: isGxzzSite.value,
	trackingChannel: GXZZ_TRACKING_CHANNEL.SUBSITE_RIGHT_NAV,
}));

const gxzzNewsList = computed(() => (isGxzzSite.value ? gxzzHeadlineList.value.filter(item => item?.title).slice(0, 5) : []));

watch(
	effectiveCompanyId,
	id => {
		companyId.value = id;
	},
	{ immediate: true }
);

/** SSR + 客户端首屏：站点信息必须在 setup 阶段就绪，TDK 才能进首包 HTML */
const { data: websitePayload } = await useAsyncData(
	() => `child-site-index-website-${String(effectiveCompanyId.value ?? '')}`,
	async () => {
		const id = effectiveCompanyId.value;
		if (!id) return null;
		try {
			return await queryWebsiteByCompanyId(id);
		} catch (e) {
			console.error('获取站点信息失败:', e);
			return null;
		}
	},
	{ watch: [effectiveCompanyId] }
);

function applyWebsitePayloadToState(res) {
	if (!res?.data) return;
	companyInfo.value = res.data;
	if (res.data.companyId != null && res.data.companyId !== '') {
		companyId.value = res.data.companyId;
	}
}

applyWebsitePayloadToState(websitePayload.value);
watch(websitePayload, applyWebsitePayloadToState);

const isGxzzSite = computed(() => isGxzzFromWebsiteData(websitePayload.value?.data));

/**
 * 上报国械智造子站首页点击，只处理需求指定的四个入口。
 * @param {string} buttonName 埋点按钮名称
 */
const trackGxzzSubsiteHomeClick = buttonName => {
	if (!isGxzzSite.value || !buttonName) return;
	trackEvent({
		module: '国械智造站点首页',
		eventCode: 'gxzz_subsites_homepage_click',
		eventName: '国械智造站点首页点击',
		attrName: 'button_name',
		attrCode: buttonName,
	});
};

/**
 * 记录国械智造子站首页商品卡片进入详情页的来源。
 * @param {MouseEvent} event 页面点击事件
 */
const handleGxzzProductNavigationClick = event => {
	if (!isGxzzSite.value || !(event.target instanceof Element)) return;
	const productLink = event.target.closest('a[href]');
	setGxzzProductTrackingContextByHref(productLink?.getAttribute('href'), GXZZ_TRACKING_CHANNEL.SPECIAL_PRODUCT_CARD);
};

/** SSR：上架商品数进首包 HTML（对齐 certification 多 useAsyncData 写法） */
const { data: ssrProductCount } = await useAsyncData(
	() => `child-site-index-product-count-${String(websitePayload.value?.data?.companyCode ?? '')}`,
	async () => {
		const code = websitePayload.value?.data?.companyCode;
		if (!code) return 0;
		try {
			const res = await getActiveProduct({ companyCode: code });
			if (Number(res?.code) === 200) return Number(res.data?.productCount) || 0;
		} catch (error) {
			console.error('获取上架商品数失败:', error);
		}
		return 0;
	},
	{ watch: [websitePayload] }
);

const pageTitle = computed(() => {
	const companyFullName = companyInfo.value?.fullName || companyInfo.value?.companyName || companyInfo.value?.websiteName || '';
	return companyFullName ? `${companyFullName}-国械在线` : '国械在线';
});

const pageDescription = computed(() => {
	const companyFullName = companyInfo.value?.fullName || companyInfo.value?.companyName || companyInfo.value?.websiteName || '该公司';
	const province = companyInfo.value?.province || '';
	return `${companyFullName}是国药器械在${province}设立的官方分子公司，运营国械在线官方子站。${companyFullName}为本地医疗机构提供合规、高效、可信赖的医疗器械B2B采购与供应链服务。`;
});

const pageKeywords = computed(() => {
	const companyFullName = companyInfo.value?.fullName || companyInfo.value?.companyName || companyInfo.value?.websiteName || '公司名全称';
	return `${companyFullName},国械在线,国药器械B2B电商平台,医疗器械采购平台`;
});

const canonicalHref = computed(() => {
	const pcBase = (config.public.publicPcUrl || '').replace(/\/$/, '');
	const cid = String(companyId.value || route.params.companyId || '').trim();
	if (!pcBase || !cid) return '';
	return `${pcBase}/${cid}`;
});

useSeoMeta({
	title: () => pageTitle.value,
	ogTitle: () => pageTitle.value,
	description: () => pageDescription.value,
	ogDescription: () => pageDescription.value,
	keywords: () => pageKeywords.value,
	ogImage: 'https://uat-cmdc.oss-cn-beijing.aliyuncs.com/productFile/2022/08/18/9af2756f-27bf-4d1e-b0d1-8397e82bb2a0.png',
});

useHead({
	link: computed(() => (canonicalHref.value ? [{ rel: 'canonical', href: canonicalHref.value }] : [])),
});

// 图片压缩处理
const compPic = url => compressPic(url || '', 50);

const syncGxzzSessionForSpecial = () => {
	setIsGxzzSession(Boolean(isGxzzSite.value));
};

// 获取轮播图
const getBannerListFun = async id => {
	try {
		let res;
		if (isLogin.value) {
			res = await getBannerList({ companyId: id, terminalType: 0 });
		} else {
			res = await getBannerListNoLogin({ companyId: id, terminalType: 0 });
		}

		if (res.code == 200 && res.data != null) {
			banner.value = res.data.filter(item => {
				const invalidDate = dayjs(item.invalidTime);
				const validDate = dayjs(item.validTime);
				const now = dayjs();
				return invalidDate > now && validDate < now;
			});
		}
	} catch (error) {
		console.error('获取轮播图失败:', error);
	}
};

// 获取资讯列表
const getNewsListsFun = async id => {
	try {
		let res;
		if (isLogin.value) {
			res = await getNewsList({ companyId: id });
		} else {
			res = await getNewsListNoLogin({ companyId: id });
		}

		if (res.code == 200) {
			newsList.value = res.data;
		}
	} catch (error) {
		console.error('获取资讯失败:', error);
	}
};

const getGxzzHeadlineListFun = async () => {
	if (!isGxzzSite.value) {
		gxzzHeadlineList.value = [];
		return;
	}

	try {
		const res = await getHotNews({
			theTt: 1,
			theMaster: 1,
			companyId: 1,
			pageNumber: 1,
			pageNum: 1,
			pageSize: 10,
			isGxzz: 1,
		});

		if (res?.code == 200) {
			gxzzHeadlineList.value = Array.isArray(res?.data?.list) ? res.data.list : [];
		} else {
			gxzzHeadlineList.value = [];
		}
	} catch (error) {
		gxzzHeadlineList.value = [];
		console.error('获取国械智造站内头条失败:', error);
	}
};

// 获取分类列表
const getClassifyList = async () => {
	try {
		const res = await getMobileCategory({
			companyId: companyId.value,
			categoryLevel: 1,
			childrenSign: false,
			pageSize: 999,
			pageNum: 1,
		});

		if (res.code == 200) {
			productCategoryList.value = res.data.list.slice(0, 6);
		}
	} catch (error) {
		console.error('获取分类失败:', error);
	}
};

// 合并图片配置
const mergePreviewImgConfig = arr => {
	const ret = arr
		.map(x => {
			x.previewImgUrl = String(x.jumpType) === '1' ? x.imgUrl : '';
			return x;
		})
		.sort((a, b) => a.sort - b.sort);
	return ret;
};

// 轮播图点击
const getBannerHref = item => {
	if (Number(item?.isLogIn) === 1 && !getStorageSync('cmdc_access_token_mobile')) {
		return '/login';
	}
	if (item?.jumpType == 1) {
		return item?.imgUrl ? '/bannerImagePreview' : '';
	}
	if (!item?.mobileLinkUrl) return '';
	return resolveMappedHref(item.mobileLinkUrl, item.title || '轮播图');
};

const bannerjumpTo = item => {
	// 后台配置需登录：未登录先跳登录页（登录成功后可按 stepRouter 回跳，与购物车等一致）
	if (Number(item.isLogIn) === 1 && !getStorageSync('cmdc_access_token_mobile')) {
		if (import.meta.client) {
			setStorageSync('stepRouter', route.fullPath || '/');
		}
		return navigateTo('/login', { replace: true });
	}

	if (item.jumpType == 1) {
		if (!item.imgUrl) return;
		window.sessionStorage.setItem('banner-image-preview', item.imgUrl);
		navigateTo('/bannerImagePreview');
		return;
	}

	if (!item.mobileLinkUrl) return;
	navigateByMappedUrl(item.mobileLinkUrl, item.title || '轮播图');
};

// 分类点击
const getClassifyHref = item => {
	if (!item?.categoryId) return '';
	return buildCategoryDetailPath(companyId.value, item.categoryId);
};

const toClassify = item => {
	const href = getClassifyHref(item);
	if (!href) return;
	navigateTo(href);
};

// 更多分类点击
const getMoreClassifyHref = () => {
	if (!companyId.value) return '';
	return `/${companyId.value}/c`;
};

const toMoreClassify = () => {
	setStorageSync('searchCompanyId', companyId.value);
	const href = getMoreClassifyHref();
	if (href) navigateTo(href);
};

// 资讯点击
const getInfoHref = () => {
	if (!companyId.value) return '';
	return `/gyInfo/list?companyId=${encodeURIComponent(companyId.value)}`;
};

const toInfo = async () => {
	setStorageSync('infoTitle', '店铺资讯');
	const href = getInfoHref();
	if (!href) return;
	navigateTo({
		path: '/gyInfo/list',
		query: {
			companyId: companyId.value,
		},
	});
};

// 商品详情点击
const getProductDetailHref = item => mobileProductDetailPath(item?.companyId, item?.productId) || '';

const toProductDitall = item => {
	const path = getProductDetailHref(item);
	if (path) navigateTo(path);
};

// 厂家商品点击
const getFactoryProductHref = item => {
	const rawUrl = item?.mapLinkUrl?.trim();
	if (!rawUrl) return '';
	try {
		const parsedUrl = new URL(rawUrl, 'http://localhost');
		if (parsedUrl.pathname.includes('/specialArea') || parsedUrl.pathname.includes('/storeSpecialArea')) {
			const specialId =
				parsedUrl.searchParams.get('id') || parsedUrl.pathname.match(/\/(?:specialArea|storeSpecialArea)\/([^/?#]+)/i)?.[1] || '';
			const specialPath = mobileSpecialDetailPath(specialId);
			if (specialPath) return specialPath;
		}
	} catch {
		// URL 解析失败时走原始链接
	}
	return rawUrl;
};

const toProductDitall1 = item => {
	const href = getFactoryProductHref(item);
	if (!href) return;
	if (href.startsWith('/special/')) {
		syncGxzzSessionForSpecial();
	}
	if (/^https?:\/\//i.test(href)) {
		navigateTo(href, { external: true });
		return;
	}
	navigateTo(href);
};

const resolveMappedHref = (url, columnTitleName) => {
	if (!url) return '';

	const mappedUrl = mateUrl(url, columnTitleName);
	if (mappedUrl) return mappedUrl;

	if (url.indexOf('/') !== 0) {
		return !url.includes('://') ? `http://${url}` : url;
	}

	return url;
};

const navigateByMappedUrl = (url, columnTitleName) => {
	const href = resolveMappedHref(url, columnTitleName);
	if (!href) return;

	if (href.startsWith('/special/')) {
		syncGxzzSessionForSpecial();
	}

	const isExternal = /^https?:\/\//i.test(href);
	navigateTo(href, isExternal ? { external: true } : undefined);
};

// 更多点击
const getMoreHref = item => {
	if (!item?.moreInfoUrl) return '';
	return resolveMappedHref(item.moreInfoUrl, item.title || '专区');
};

const toMore = item => {
	const href = getMoreHref(item);
	if (!href) return;
	navigateByMappedUrl(item.moreInfoUrl, item.title || '专区');
};

// 卡片更多 URL 点击
const getCardHref = item => {
	const previewImgUrl = item.previewImgUrl || '';
	if (previewImgUrl) return '/bannerImagePreview';

	// 完整链接（含域名或带 query）统一走映射逻辑
	if (typeof item.linkUrl === 'string' && (item.linkUrl.includes('://') || item.linkUrl.includes('?'))) {
		return resolveMappedHref(item.linkUrl, item.title || '专区');
	}

	const rawQuery = item.linkQuery || item.linkUrl || '';
	if (!rawQuery) return '';
	const extraQuery = Object.fromEntries(new URLSearchParams(rawQuery));
	if (!Object.keys(extraQuery).length) return '';
	return mobileSpecialDetailPath(extraQuery.id) || '';
};

const toMoreURL = item => {
	const href = getCardHref(item);
	if (!href) return;

	const previewImgUrl = item.previewImgUrl || '';
	if (previewImgUrl) {
		window.sessionStorage.setItem('banner-image-preview', previewImgUrl);
		navigateTo('/bannerImagePreview');
		return;
	}

	if (typeof item.linkUrl === 'string' && item.linkUrl.includes('?')) {
		navigateByMappedUrl(item.linkUrl, item.title || '专区');
		return;
	}

	if (href.startsWith('/special/')) {
		syncGxzzSessionForSpecial();
	}

	// 未命中站内映射的完整链接按外链打开，否则会被 navigateTo 当成站内路由
	if (/^https?:\/\//i.test(href)) {
		navigateTo(href, { external: true });
		return;
	}
	navigateTo(href);
};

// 滚动监听
const handleScroll = () => {
	scrollTop.value = window.scrollY || document.documentElement.scrollTop;
};

// 初始化页面数据（站点信息已由 useAsyncData 在 SSR/setup 写入 companyInfo）
const initPage = async ({ ssr = false } = {}) => {
	placeholders.value = '搜本店';
	isLogin.value = ssr ? false : !!getStorageSync('cmdc_access_token_mobile');

	factoryDataList.value = [];
	hotProductData.value = [];
	productData.value = [];
	cardList.value = [];
	banner.value = [];
	newsList.value = [];
	productCategoryList.value = [];
	publishTypeMap.value = {};

	if (!ssr && isLogin.value && companyInfo.value?.companyCode) {
		await getUserSite({
			companyId: companyId.value,
			companyCode: companyInfo.value.companyCode,
		});
	}

	// 获取楼层数据
	await fetchAllIndexContents();

	// 获取其他数据 - 添加 card 类型
	await getBannerListFun(companyId.value);
	await getIndexContent('card', { ssr });
	await getIndexContent('factory', { ssr });
	await getIndexContent('product', { ssr });
	await getIndexContent('theme', { ssr });
	await getNewsListsFun(companyId.value);
	await getGxzzHeadlineListFun();
	await getClassifyList();
};

// 并发请求获取楼层数据
const fetchAllIndexContents = async () => {
	try {
		const res = await queryByCompanyIdAndPublishTypeAll({
			companyId: companyId.value,
			terminalType: 0,
		});

		const allFloorData = res.data;
		if (!allFloorData || !Array.isArray(allFloorData)) {
			console.warn('楼层数据为空或不是数组');
			return;
		}

		const [floorList] = resolveFloor(allFloorData);
		floorListData.value = floorList;

		// 以旧项目的楼层拆解结果为准，按 publishType 分组
		publishTypeMap.value = floorList.reduce((acc, item) => {
			const key = item.publishType;
			if (!acc[key]) acc[key] = [];
			acc[key].push(item);
			return acc;
		}, {});
	} catch (error) {
		console.error('获取楼层数据失败:', error);
	}
};

// 解析楼层数据
const resolveFloor = arr => {
	if (!arr || !Array.isArray(arr)) {
		return [[]];
	}

	let floorList = arr.map(x => {
		const jsonData = parseJSON(x);
		jsonData.forEach(item => {
			item.publishType = x.publishType;
		});
		return _.omit(
			{
				...x,
				contentList: jsonData,
			},
			['json']
		);
	});

	floorList = floorList.reduce((acc, cur) => {
		if (cur.contentList.length > 0 && cur.publishType !== 'card' && cur.publishType !== 'navigation') {
			cur.contentList.forEach(cItem => {
				acc.push({
					..._.omit(cur, ['contentList']),
					contentList: [cItem],
				});
			});
		} else {
			acc.push(cur);
		}
		return acc;
	}, []);

	floorList = floorList
		.map(x => {
			const obj0 = x.contentList && x.contentList[0];
			return {
				...x,
				..._.pick(obj0, ['columnId', 'companyId', 'isPublish', 'disableSign', 'sort']),
			};
		})
		.sort((a, b) => Number(b.sort) - Number(a.sort));

	return [floorList];
};

// 解析 JSON
const parseJSON = item => {
	return item.json ? JSON.parse(item.json) : {};
};

// 统一读取楼层内容（兼容 resolveFloor 前后两种结构）
const getPublishContentList = data => {
	if (!Array.isArray(data) || data.length === 0) return [];
	return data.flatMap(row => {
		if (Array.isArray(row?.contentList)) return row.contentList;
		if (row?.json) {
			try {
				const parsed = JSON.parse(row.json);
				return Array.isArray(parsed) ? parsed : [];
			} catch (error) {
				return [];
			}
		}
		return [];
	});
};

// 卡片展示状态：参考 banner 的时间窗，同时兼容后台上下架状态
const isCardShowing = item => {
	const now = Date.now();
	const activateTime = Number(item?.activateTime || 0);
	const expirationTime = Number(item?.expirationTime || 0);
	const isPublished = Number(item?.isPublish) === 2;
	const isEnabled = Number(item?.disableSign || 0) !== 1;
	const isInTimeWindow = (!activateTime || activateTime <= now) && (!expirationTime || now < expirationTime);
	return isPublished && isEnabled && isInTimeWindow;
};

// 获取栏目卡片
const getIndexContent = async (type, { ssr = false } = {}) => {
	try {
		const res = {
			data: publishTypeMap.value[type],
		};

		if (type === 'factory' && res.data?.length > 0) {
			const factoryData = getPublishContentList(res.data);
			factoryData.forEach(item => {
				item.columnProductList.forEach((items, index) => {
					let Id = items.mapLinkUrl.split('?')[1];
					items.id = Id;
					if (items.position === 'main') {
						item.columnProductList.splice(index, 1);
					}
				});
			});
			factoryDataList.value = factoryData;
		}

		// 收集所有产品数据到 productData，参考 DC 项目逻辑
		if (type === 'product' && res.data?.length > 0) {
			const hotProduct = getPublishContentList(res.data);
			hotProduct.forEach(item => {
				let Id = item.moreInfoUrl.split('?')[1];
				productData.value.push({
					id: Id,
					title: item.title,
					list: item.columnProductList,
					moreInfoUrl: item.moreInfoUrl,
					companyId: item.companyId,
				});
			});
		}

		if (type === 'theme' && res.data?.length > 0) {
			const themeData = getPublishContentList(res.data);
			themeData.forEach(item => {
				let leftId = item.leftLinkUrl?.split('?')[1];
				let rightId = item.rightLinkUrl?.split('?')[1];
				let leftList = [];
				let rightList = [];
				item.leftList.forEach((it, z) => {
					if (z <= 1) {
						leftList.push(it);
					}
				});
				item.rightList.forEach((it, z) => {
					if (z <= 1) {
						rightList.push(it);
					}
				});

				if (leftList.length > 0) {
					leftList.unshift({
						linkUrl: item.leftImageUrl || item.leftLinkUrl,
					});
				}
				if (rightList.length > 0) {
					rightList.unshift({
						linkUrl: item.rightImageUrl || item.rightLinkUrl,
					});
				}

				// 推送到 productData，和 DC 项目一致
				productData.value.push(
					{
						id: leftId,
						title: item.leftTitle,
						list: leftList,
						companyId: item.companyId,
						moreInfoUrl: item.leftLinkUrl,
						viewType: '1p2',
					},
					{
						id: rightId,
						title: item.rightTitle,
						list: rightList,
						companyId: item.companyId,
						moreInfoUrl: item.rightLinkUrl,
						viewType: '1p2',
					}
				);
			});
		}

		// 处理 card 类型
		if (type === 'card' && res.data?.length > 0) {
			const cardListData = getPublishContentList(res.data).filter(isCardShowing);
			cardListData.forEach(item => {
				// 保留原始 linkUrl，避免覆盖后影响统一跳转逻辑
				if (typeof item.linkUrl === 'string' && item.linkUrl.indexOf(';') === -1) {
					item.linkQuery = item.linkUrl.split('?')[1] || '';
				}
			});
			cardList.value = cardListData;
		}

		// 统一分配 bg 值，参考 DC 项目 607-617 行
		productData.value.forEach((items, j) => {
			// 兜底补齐 companyId，避免详情跳转时参数缺失
			items.companyId = items.companyId || companyId.value;
			if (j >= 8) {
				items.bg = 'bg' + (j - 8);
			} else {
				items.bg = 'bg' + j;
			}
			items.list.map(list => {
				list.companyCode = list.companyCode;
				list.companyId = list.companyId || items.companyId || companyId.value;
				list.specifications = list.specifications || list.specs || list.optionStr || '';
				list.optionStr = list.optionStr || list.specs || list.specifications || '';
				list.manufacturer = list.manufacturer || list.supplierCompanyName || '';
				list.materialcode = list.materialcode || list.materialCode || '';
				list.measuringUnit = list.measuringUnit || list.measuringunit || '';
				// BigImg/SmallImg 用 websiteName 渲染“站点经销”名称，这里做兜底补齐
				list.websiteName =
					list.websiteName || list.supplierCompanyName || companyInfo.value?.websiteName || companyInfo.value?.companyName || '';
			});
		});

		// 赋值给 hotProductData
		hotProductData.value = productData.value;

		if (!ssr) {
			// 补齐价格字段：部分楼层数据不带 price/referenceprice，需二次查询
			const allProducts = hotProductData.value.flatMap(item => item.list || []).filter(item => item && item.productId);
			await fillGoodsPrice(allProducts);

			// 获取优惠券信息
			if (productData.value.length > 0) {
				const productList = productData.value.flatMap(item => item.list).filter(item => item && item.productId);
				await getDiscountListFun(productList);
			}
		}
	} catch (error) {
		console.error('获取栏目数据失败:', error);
	}
};

// 回填商品价格字段（对齐搜索/列表页做法）
const fillGoodsPrice = async list => {
	try {
		const productIds = list.map(item => item.productid || item.productId).filter(Boolean);
		if (!productIds.length) return;

		const hasAccessToken = import.meta.client ? !!getStorageSync('cmdc_access_token_mobile') : !!isLogin.value;
		if (!hasAccessToken) return;
		const res = await getGoodsPricePre(productIds);
		if (res.code == 200 && Array.isArray(res.data)) {
			res.data.forEach(priceItem => {
				list.forEach(goodsItem => {
					if ((goodsItem.productid || goodsItem.productId) === (priceItem.productid || priceItem.productId)) {
						goodsItem.price = priceItem.price ?? goodsItem.price;
						// 楼层商品后续会混用新旧价格字段，这里一次性补齐并保留 0 值。
						mergeProductPriceFields(goodsItem, priceItem);
						goodsItem.iscontrolsales = priceItem.iscontrolsales;
						goodsItem.issee = priceItem.issee;
					}
				});
			});
		}
	} catch (error) {
		console.error('回填商品价格失败:', error);
	}
};

// 获取优惠券列表
const getDiscountListFun = async list => {
	try {
		const listProductIds = list.map(item => ({
			productCode: item.productcode || item.productCode,
			productId: item.productId,
			companyCode: item.companyCode,
		}));

		const resCoupons = await getDiscountList(listProductIds);
		if (resCoupons.code == 200) {
			hotProductData.value.forEach(item => {
				item.list.forEach(item1 => {
					resCoupons.data.forEach(item2 => {
						if (item1.productId === item2.productId) {
							item1.zero = item2.zero;
							item1.coupon = item2.coupon;
							if (item2.activity) {
								item1.activityType = item2.activity.activityType;
							}
						}
					});
				});
			});
		}
	} catch (err) {
		console.error('获取优惠券失败:', err);
	}
};

function snapshotIndexPageState() {
	return {
		banner: banner.value,
		newsList: newsList.value,
		productCategoryList: productCategoryList.value,
		cardList: cardList.value,
		factoryDataList: factoryDataList.value,
		hotProductData: hotProductData.value,
		publishTypeMap: publishTypeMap.value,
		floorListData: floorListData.value,
		gxzzHeadlineList: gxzzHeadlineList.value,
	};
}

function applyIndexPageState(payload) {
	if (!payload) return;
	banner.value = payload.banner ?? [];
	newsList.value = payload.newsList ?? [];
	productCategoryList.value = payload.productCategoryList ?? [];
	cardList.value = payload.cardList ?? [];
	factoryDataList.value = payload.factoryDataList ?? [];
	hotProductData.value = payload.hotProductData ?? [];
	productData.value = payload.hotProductData ?? [];
	publishTypeMap.value = payload.publishTypeMap ?? {};
	floorListData.value = payload.floorListData ?? [];
	gxzzHeadlineList.value = payload.gxzzHeadlineList ?? [];
}

/** SSR + 首屏：正文数据 useAsyncData 拉取后写入 ref（须在 initPage 定义之后，避免 TDZ） */
const { data: indexPagePayload } = await useAsyncData(
	() => `child-site-index-content-${String(effectiveCompanyId.value ?? '')}`,
	async () => {
		const id = effectiveCompanyId.value;
		if (!id || !websitePayload.value?.data) return null;

		applyWebsitePayloadToState(websitePayload.value);
		companyId.value = id;
		await initPage({ ssr: true });
		return snapshotIndexPageState();
	},
	{ watch: [effectiveCompanyId] }
);

/** 登录态下补拉价格/优惠券（SSR 未登录场景跳过） */
const refreshLoginOnlyIndexData = async () => {
	if (!isLogin.value) return;
	if (companyInfo.value?.companyCode) {
		await getUserSite({
			companyId: companyId.value,
			companyCode: companyInfo.value.companyCode,
		});
	}
	const allProducts = hotProductData.value.flatMap(item => item.list || []).filter(item => item && item.productId);
	await fillGoodsPrice(allProducts);
	if (hotProductData.value.length > 0) {
		const productList = hotProductData.value.flatMap(item => item.list).filter(item => item && item.productId);
		await getDiscountListFun(productList);
	}
};

applyIndexPageState(indexPagePayload.value);
watch(indexPagePayload, async payload => {
	applyIndexPageState(payload);
	if (import.meta.client && payload) {
		isLogin.value = !!getStorageSync('cmdc_access_token_mobile');
		await refreshLoginOnlyIndexData();
	}
});

// 生命周期
onMounted(async () => {
	window.addEventListener('scroll', handleScroll);
	isLogin.value = !!getStorageSync('cmdc_access_token_mobile');
	if (isGxzzSite.value && companyId.value) {
		const channelType = consumeGxzzTrackingContext(GXZZ_TRACKING_TARGET.SUBSITE, companyId.value);
		trackEvent({
			companyCode: companyInfo.value?.companyCode || '',
			module: '国械智造站点首页',
			eventCode: 'gxzz_subsites_homepage_enter',
			eventName: '进入国械智造站点首页',
			attrName: 'channel_type',
			attrCode: channelType,
		});
	}

	// useAsyncData 失败时的客户端兜底
	if (import.meta.client && !indexPagePayload.value) {
		await initPage();
		return;
	}
	await refreshLoginOnlyIndexData();
});

onUnmounted(() => {
	window.removeEventListener('scroll', handleScroll);
});
</script>
<style scoped lang="scss">
.gxzz-consult-floor {
	margin-top: 0.75rem;
}

.flex {
	display: flex;
	padding: 0 1rem;
	justify-content: space-between;
	align-items: center;

	&.top {
		align-items: flex-start;
	}

	&.start {
		justify-content: flex-start;
	}

	&.center {
		justify-content: center;
	}

	&.end {
		justify-content: flex-end;
	}

	&.no-pad {
		padding: 0;
	}
}

.swiper {
	width: 100%;
	height: 15.2rem;
}

.swiper-item {
	width: 100%;
	height: 100%;

	.banner-link {
		display: block;
		width: 100%;
		height: 100%;
		text-decoration: none;
		color: inherit;
	}

	:deep(img) {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}

.title {
	display: flex;
	align-items: center;
	justify-content: space-around;
	width: 100%;
	padding: 0.8rem 1.5rem 0;
	line-height: 1rem;
	color: #46539d;
	font-size: 1rem;

	span {
		position: relative;

		&::before {
			position: absolute;
			top: 50%;
			left: -1rem;
			transform: translateY(-50%);
			content: '';
			display: inline-block;
			margin-right: 0.5rem;
			width: 0.5rem;
			height: 0.5rem;
			border-radius: 50%;
			background: #7f90f5;
		}
	}
}

.title-box {
	@extend .flex;
	padding: 0.8rem 1.5rem 0;
	line-height: 1rem;
	color: #46539d;
	font-size: 1rem;

	span {
		position: relative;

		&::before {
			position: absolute;
			top: 50%;
			left: -1rem;
			transform: translateY(-50%);
			content: '';
			display: inline-block;
			margin-right: 0.5rem;
			width: 0.5rem;
			height: 0.5rem;
			border-radius: 50%;
			background: #7f90f5;
		}
	}
}

.gykx-box {
	@extend .flex;
	display: flex;
	text-decoration: none;
	color: inherit;
	padding: 0.5rem 0.5rem 0.5rem 1rem;
	background: #fff;

	.gykx-content {
		@extend .flex;
		@extend .no-pad;

		img {
			width: 6.17rem;
			height: 1.57rem;
		}

		.lunbo {
			width: 18.25rem;
			height: 1.5rem;
			margin-left: 2rem;
			overflow: hidden;

			:deep(.van-swipe-item) {
				height: 1.5rem;
				line-height: 1.5rem;
			}

			.text {
				width: 100%;
				display: block;
				font-size: 1rem;
				font-family: NotoSansSC-Regular, NotoSansSC;
				font-weight: 400;
				color: #606266;
				line-height: 1.5rem;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}

	.icon-gongneng_xiangyou-37 {
		font-size: 1rem;
		color: #909399;
	}
}

.bg {
	background-color: #fff;
	width: 100%;
}

.specialListBox {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	padding: 0.25rem 0.67rem 0.42rem;
	justify-content: space-between;

	.specialList {
		display: block;
		text-decoration: none;
		color: inherit;
		width: 50%;
		height: 6.05rem;
		padding: 0.5rem;

		img {
			width: 100%;
			height: 100%;
		}
	}
}

.search {
	padding: 0.58rem 1rem;
}

.gykx {
	padding: 0.5rem 0.5rem 0.5rem 1rem;
	background: #fff;

	img {
		width: 6.17rem;
		height: 1.57rem;
	}

	.lunbo {
		width: 18.25rem;
		height: 1.5rem;
		margin-left: 2rem;
		overflow: hidden;

		:deep(.van-swipe-item) {
			height: 1.5rem;
			line-height: 1.5rem;
		}

		.text {
			width: 100%;
			display: block;
			font-size: 1rem;
			font-family: NotoSansSC-Regular, NotoSansSC;
			font-weight: 400;
			color: #606266;
			line-height: 1.5rem;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}

	.icon-gongneng_xiangyou-37 {
		font-size: 1rem;
		color: #909399;
	}
}

.speciaBox {
	margin-top: 0.75rem;
	width: 100%;
	padding: 1rem 1.08rem 1rem 1.25rem;
	background-color: #fff;
	&.speciaBox_1p2 {
		padding-top: 0;
		padding-bottom: 0 !important;
	}

	.topTitle {
		display: flex;
		justify-content: space-between;
		align-items: center;
		text-decoration: none;
		color: inherit;

		.icon-gongneng_sandiangengduo {
			font-size: 1.5rem;
			color: #c0c4cc;
		}
	}

	.more-link {
		flex: 1;
		display: flex;
		justify-content: flex-end;
		text-decoration: none;
		color: inherit;

		.icon-gongneng_sandiangengduo {
			font-size: 1.5rem;
			color: #c0c4cc;
		}
	}

	.TopBoxTitle {
		flex: 1;
		font-size: 1.5rem;
		font-family:
			PingFangSC-Medium,
			PingFang SC;
		font-weight: 600;
		color: #46539d;
		line-height: 2.08rem;
	}

	.bg0 {
		letter-spacing: 1px;
		background: linear-gradient(129deg, #22c4d0 0%, #7927e4 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.bg1 {
		letter-spacing: 1px;
		background: linear-gradient(129deg, #a89dfc 0%, #154dda 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.bg2 {
		letter-spacing: 1px;
		background: linear-gradient(129deg, #74d385 0%, #00a0aa 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.bg3 {
		letter-spacing: 1px;
		background: linear-gradient(129deg, #15d0c1 0%, #0073d3 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.bg4 {
		letter-spacing: 1px;
		background: linear-gradient(129deg, #1582fc 0%, #0a24f4 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.bg5 {
		letter-spacing: 1px;
		background: linear-gradient(129deg, #ac4ffa 0%, #4008d5 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.bg6 {
		letter-spacing: 1px;
		background: linear-gradient(129deg, #eed105 0%, #3cd500 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.bg7 {
		letter-spacing: 1px;
		background: linear-gradient(129deg, #ecc815 0%, #fd6a8f 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.bg8 {
		letter-spacing: 1px;
		background: linear-gradient(129deg, #fea10a 0%, #f82c26 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.productList1 {
		display: flex;
		flex-wrap: wrap;
		margin-top: 0.75rem;

		.productBox {
			display: block;
			text-decoration: none;
			color: inherit;
			border-radius: 1px solid #ccc;
			padding: 0.1rem;
			flex: 50%;
			box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(219, 218, 219, 0.7);
		}
	}

	.productList {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: 0.75rem;

		.productBox {
			width: 9rem;
			padding: 0.5rem 0.58rem 0.92rem;

			.titles {
				height: 2.8rem;
				font-size: 1rem;
				font-family: NotoSansSC-Regular, NotoSansSC;
				font-weight: 400;
				color: #606266;
				line-height: 1.5rem;
				width: 8rem;
				white-space: initial;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				/*第几行出现省略号*/
				-webkit-box-orient: vertical;
			}
		}
	}
}

/* 1p2 布局样式 */
.layout-1-2 {
	display: flex;
	gap: 4px;
	align-items: center;
	padding-top: 4px;
	padding-bottom: 4px;

	.left-banner {
		display: block;
		text-decoration: none;
		color: inherit;
		width: 112px;
		height: 185px;
		border-radius: 0.5rem;
		overflow: hidden;
		position: relative;
		background: linear-gradient(180deg, #a8e6e6 0%, #7dd3d3 100%);
		flex-shrink: 0;
	}

	.right-products {
		flex: 1;
		display: flex;
		gap: 4px;

		.product-card {
			flex: 1;
			border-radius: 0.33rem;
			padding: 0.5rem;
			display: flex;
			flex-direction: column;
			:deep(.mini-list) {
				padding: 0;
			}
			:deep(.mini-list .mini-list-item) {
				justify-content: center;
				min-width: initial !important;
				max-width: initial !important;
				gap: 4px;
			}
			:deep(.mini-list .mini-list-item .goods-detail) {
				padding-top: 2px;
			}
			:deep(.mini-list .mini-list-item .product-image) {
				width: 90px !important;
				height: 90px !important;
				margin: 0 auto;
			}
		}
	}
}

.ClassifyBox {
	margin-top: 0.75rem;
	width: 100%;
	padding: 0.75rem 0 0;
	background-color: #fff;

	.topTitle {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 1.25rem;
		text-decoration: none;
		color: inherit;

		.icon-gongneng_sandiangengduo {
			font-size: 1.5rem;
			color: #c0c4cc;
		}
	}

	.HotTitle {
		font-size: 1.5rem;
		font-family:
			PingFangSC-Medium,
			PingFang SC;
		font-weight: 600;
		color: #fb5757;
		line-height: 2.08rem;
		letter-spacing: 1px;
		background: linear-gradient(129deg, rgba(251, 175, 30, 0.75) 0%, rgba(220, 27, 52, 0.78) 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.hotList {
		display: flex;
		flex-wrap: wrap;
		margin-top: 0.83rem;

		.hotClassifyBox {
			display: block;
			text-decoration: none;
			color: inherit;
			width: 7.73rem;
			padding: 1rem 1.04rem 0.58rem;

			.titles {
				font-size: 1rem;
				font-family: NotoSansSC-Regular, NotoSansSC;
				font-weight: 400;
				color: #606266;
				line-height: 1.5rem;
				white-space: initial;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				/*第几行出现省略号*/
				-webkit-box-orient: vertical;
				margin-top: 1.17rem;
				text-align: center;
			}
		}
	}
}

.coupon-tips {
	position: absolute;
	left: 0;
	top: 0;
	width: 1.67rem;
	height: 1.33rem;
	line-height: 1.33rem;
	background: #fd6367;
	box-shadow: 0rem -0.08rem 0rem 0rem rgba(255, 204, 170, 0.54);
	border-radius: 0rem 8.33rem 8.33rem 0rem;
	z-index: 2;
	text-align: center;
	color: #fff;
	font-size: 1rem;
}

.sku-wrap {
	padding-top: 0.3rem;
}

.mainBox {
	padding-bottom: calc(4.17rem + env(safe-area-inset-bottom));
}
</style>
